import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Layout } from "antd";
//components
import BreakpointNumCol from "../../component/breakpointNumCol";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import GroupService from "./component/group_service";
import ListService from "./component/list_service";
//dialog
import DialogGroupAdd from "./dialog/dialog_group_add";
import DialogGroupDetail from "./dialog/dialog_group_detail";
import DialogServiceAdd from "./dialog/dialog_service_add";
import DialogServiceDetail from "./dialog/dialog_service_detail";

//redux
import { useDispatch, useSelector } from "react-redux";
import { snapGroup, unSnapGroup } from "../../store/group_service/group.action";
import { snapAllServices, unSnapAll } from "../../store/service/service.action";
import { getBranchByShopId } from "../../store/branch/branch.action";
import { detailSelector } from "../../store/branch/branch.selector";
//style
import "./style.css";

const { Content } = Layout;

const ServicesScreen = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  // const shopId = params?.shopId;
  const branchId = params?.id;
  console.log({ branchId });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branchId) {
      dispatch(snapGroup({ branch: branchId }));
      dispatch(snapAllServices({ branch: branchId }));
    }

    return () => {
      dispatch(unSnapGroup());
      dispatch(unSnapAll());
    };
  }, [dispatch, branchId]);

  // useEffect(() => {
  //   if (shopId) {
  //     dispatch(getBranchByShopId({ shopId }));
  //   }
  // }, [shopId]);
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row className="section-service">
        <Col xl={24} lg={24} md={24} xs={24}>
          <GroupService />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ListService />
        </Col>
      </Row>
    );
  };

  const renderDialog = () => {
    return (
      <>
        <DialogGroupAdd />
        <DialogServiceAdd />
        <DialogGroupDetail />
        <DialogServiceDetail />
      </>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Row align="center">
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderBody()}
        </Col>
      </Row>

      {renderDialog()}
    </>
  );
};

export default ServicesScreen;
